module.exports = __webpack_public_path__ + "img/D202007_3.9c7b60ec.jpg";